import { Mail, PencilLine, X } from 'lucide-react';

interface Props {
  open: boolean;
  email: string;
  onComposeInApp: () => void;
  onClose: () => void;
}

/**
 * Shown when the "Open in Gmail" launch couldn't reach the Gmail app on mobile
 * (best-effort heuristic — see useGmailLaunch). Offers the two reliable
 * alternatives so the rep is never stranded, plus a hint to install Gmail or
 * change their default in Settings.
 */
export function GmailFallbackDialog({ open, email, onComposeInApp, onClose }: Props) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        className="w-full max-w-sm rounded-2xl bg-white dark:bg-gray-800 shadow-xl p-5 space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between">
          <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Couldn't open the Gmail app</h3>
          <button type="button" onClick={onClose} aria-label="Close" className="text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-200">
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-300">
          Install the Gmail app, or change your default in Settings. Or send this one now:
        </p>
        <div className="space-y-2">
          <button
            type="button"
            onClick={onComposeInApp}
            className="btn-primary w-full flex items-center justify-center gap-2"
          >
            <PencilLine className="h-4 w-4" />
            Compose in the CRM
          </button>
          <a
            href={`mailto:${email}`}
            onClick={onClose}
            className="btn-secondary w-full flex items-center justify-center gap-2"
          >
            <Mail className="h-4 w-4" />
            Open in my mail app
          </a>
        </div>
      </div>
    </div>
  );
}
